<template lang="pug">
v-combobox(
    v-model="model"
    :hide-no-data="!search"
    :items="options"
    :search-input.sync="search"
    :error-messages="errors"
    hide-selected
    multiple
    small-chips
    persistent-placeholder
    filled
    background-color="lightGrey"
    class="suus__chip-select-combo"
    attach=".suus__chip-select-combo"
    )
    template(v-slot:label)
        FieldLabel(:label="label" :mandatory="mandatory")
    template(v-slot:no-data)
        v-list-item
            span(v-html="noDataFoundForSearch").body-2.pr-2 
    template(v-slot:selection="{ attrs, item, parent, selected }")
         v-chip(
            v-bind="attrs"
            color="primary"
            :input-value="selected"
            label
            small
        )
            span.pr-2  {{ item.name ? item.name : item }}
            v-icon(small @click="parent.selectItem(item)") {{ closeIcon }}
</template>

<script lang="ts">
import Vue, { PropType, ref, watch } from "vue"
import { mdiCloseCircle } from "@mdi/js"
import FieldLabel from "../../../components/UI/FieldLabel.vue"
export default Vue.extend({
  name: "ChipSelectCombo",
  components: { FieldLabel },
  props: {
    options: {
      type: Array as PropType<string[]>,
      required: false,
      default: function () {
        return []
      },
    },
    value: {
      type: Array as PropType<string[]>,
      required: false,
      default: function () {
        return []
      },
    },
    label: { type: String, required: true },
    noDataHTMLText: {
      type: String,
      default:
        "Keine Ergebnissse für <strong>${this.search}</strong>. Klicke auf <kbd>enter</kbd> um eine neue Option zu erstellen.",
    },
    mandatory: { type: Boolean, default: false },
    error: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      closeIcon: mdiCloseCircle,
      menu: false,
      model: this.value,
      search: null as string | null,
    }
  },
  computed: {
    noDataFoundForSearch(): string {
      return `${this.noDataHTMLText}`
    },
    rules() {
      return this.mandatory
        ? [
            (v: string[]) =>
              !!v.length ||
              "Bitte geben Sie mindestens einen Wert für die Auswahl an.",
          ]
        : []
    },
  },
  watch: {
    value(val: string[]) {
      this.model = val
    },
    model(val: string[], prev: string[]) {
      if (val.length === prev.length) return
      this.model = val
      this.$emit("input", val)
    },
    search(val: string, prev: string) {
      if (val === prev) return
      this.$emit("search", val)
    },
  },
  setup(props) {
    const errors = ref<string[]>([])
    if (props.error) {
      errors.value = [props.error]
    }
    watch(
      () => props.error,
      (value) => {
        errors.value = value ? [value] : []
      }
    )
    return {
      errors,
    }
  },
})
</script>

<style lang="sass" scoped>
%font-stack
    font-family: system-ui !important
    font-size: 1.2rem !important
    font-weight: 300
.suus__chip-select-combo::v-deep
    @extend %font-stack
    .v-input__control
        height: auto
    .v-select__slot
        .v-label
            top: 15px
    .v-select-list
        .v-list-item
            border-bottom: 1px solid #e5e5e5 !important
::v-deep div.v-select__selections
    padding-top: 30px !important
</style>
